module.exports = __webpack_public_path__ + "media/icons/star-full-adeb59b94f4a6df2ff3b48fecfa9365e.svg";